import { Checkbox, Flex, Icon, Stack, Text } from '@chakra-ui/react';

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};
type FichaData = {
	banca: string;
	cliente: string;
	cod_emp: number;
	cod_ficha: number;
	cod_ped: string;
	cod_pro: number;
	cod_event: number;
	dat_cad: string;
	descricao: string;
	imagem: string;
	nome_pro: string;
	proxima_op: string;
	quant_atual: number;
	quant_incial: number;
	status_des: string;
	usuario: string;
	apontamento: boolean;
}
interface DataTableCardsParams {
	fichas: FichaData[];
	setFichas: (fichas: FichaData[]) => void;
	pesqFichas: FichaData[];
	setPesqFichas: (fichas: FichaData[]) => void;
	controls: ControlsData;
	handleUpdateList: (page: number, perPage: number, produtos: FichaData[]) => void;
	aponta: FichaData[];
	setAponta: (fichas: FichaData[]) => void;
}

const DataTableCards: React.FC<DataTableCardsParams> = ({
	fichas,
	setFichas,
	pesqFichas,
	setPesqFichas,
	controls,
	handleUpdateList,
	aponta,
	setAponta,
}) => {
  return (
    <Flex w="100%" flexDir="column" justify="center" align="center">
      {fichas.map(ficha => {
        return (
          <Flex
						key={ficha.cod_ficha}
            justify="space-between"
            w="100%"
            bgGradient="linear(to-r, gray.50, gray.100)"
            borderRadius={8}
            boxShadow="xl"
            p="4"
            m="4"
          >
            <Flex>
              <Stack>
								{ficha.cod_ficha && (
                  <Flex align="center">
                    <Text
                      color="gray.800"
                      textTransform="uppercase"
                      fontWeight="500"
                      fontSize="14"
                    >
											{ficha.cod_ficha} - {ficha.nome_pro}
                    </Text>
                  </Flex>
                )}

								{ficha.banca && (
                  <Flex align="center">
                    <Text color="gray.600" fontSize="14">
											{ficha.banca}
                    </Text>
                  </Flex>
                )}

								{ficha.status_des && (
									<Flex align="center">
										<Text color="gray.600" fontSize="14">
											{ficha.status_des}
										</Text>
									</Flex>
								)}

								{ficha.quant_incial && (
                  <Flex align="center">
										<Text color="gray.500" fontSize="14">
											QTD: Inicial: {ficha.quant_incial} - 
											Final: {ficha.quant_atual}
                    </Text>
                  </Flex>
                )}
								{ficha.dat_cad && (
									<Flex align="center">
										<Text color="gray.500" fontSize="14">
											Data: {ficha.dat_cad}
										</Text>
									</Flex>
								)}
              </Stack>
            </Flex>

            <Flex flexDir="column" justify="start">
              <Stack direction="column" justify="space-between" align="start">
								<Checkbox
									isChecked={ficha.apontamento}
									onChange={() => {
										const auxPesqs = pesqFichas;
										const indexPesq = auxPesqs.findIndex(a => a.cod_ficha === ficha.cod_ficha);

										const auxFichas = fichas;
										const indexFichas = auxFichas.findIndex(a => a.cod_ficha === ficha.cod_ficha);

										const auxApontas = aponta;
										const auxFicha = { ...auxFichas[indexFichas], apontamento: !auxFichas[indexFichas].apontamento };

										auxPesqs[indexPesq] = auxFicha;
										auxFichas[indexFichas] = auxFicha;

										setPesqFichas(auxPesqs);
										setFichas(auxFichas);

										if (auxFicha.apontamento) {
											auxApontas.push(auxFicha);
										} else {
											const index = auxApontas.findIndex(a => a.cod_ficha === ficha.cod_ficha);
											auxApontas.splice(index, 1);
										}

										setAponta(auxApontas);
										handleUpdateList(controls.page, controls.perPage, auxPesqs);
									}}
								>
								</Checkbox>
              </Stack>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default DataTableCards;
